import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { db } from '../firebase.config';
import { collection, addDoc, doc, updateDoc } from 'firebase/firestore';
import { UserAuth } from '../context/AuthContext';

const CookieConsent = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [ipAddress, setIpAddress] = useState(null);
  const { user } = UserAuth();

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShowPopup(true);
      // Fetch IP address when popup is shown
      fetch('https://api.ipify.org?format=json')
        .then(response => response.json())
        .then(data => setIpAddress(data.ip))
        .catch(error => console.error('Error fetching IP:', error));
    }
  }, []);

  const handleAccept = async () => {
    try {
      // Store consent in Firestore Cookies collection
      await addDoc(collection(db, 'Cookies'), {
        ipAddress: ipAddress,
        timestamp: new Date().toISOString(),
        consentGiven: true
      });

      // If user is authenticated, update their document with consent date
      if (user) {
        try {
          const userDocRef = doc(db, 'Users', user.uid);
          await updateDoc(userDocRef, {
            cookieConsentRecorded: new Date().toISOString()
          });
          console.log('Cookie consent recorded in user document');
        } catch (userUpdateError) {
          console.error('Error updating user document:', userUpdateError);
          // Continue execution even if user document update fails
        }
      }

      // Store in localStorage
      localStorage.setItem('cookieConsent', 'true');
      setShowPopup(false);
    } catch (error) {
      console.error('Error storing consent:', error);
      // Still hide popup and store in localStorage even if Firestore fails
      localStorage.setItem('cookieConsent', 'true');
      setShowPopup(false);
    }
  };

  return (
    showPopup && (
      <div className="max-w-[350px] max-h-[140px] fixed bottom-4 left-4 right-4 bg-[#1b2124] text-sm text-white p-4 rounded-lg border border-gray-800 z-50">
        <p>
          We collect cookies to improve your browsing experience. By using our site, you agree to our
          <Link to="/privacy" className="underline ml-1 text-[#00df9a]">Privacy Policy </Link>
          and<Link to="/terms" className="underline ml-1 text-[#00df9a]">Terms of Service</Link>.
        </p>
        <button
          onClick={handleAccept}
          className="mt-4 py-1 cursor-pointer bg-[#12181B] border border-[#00df9a] text-[#00df9a] font-hyperlegible text-bold text-sm mr-6 px-6 rounded hover:text-black hover:bg-[#00df9a] hover:scale-105"
        >
          Accept
        </button>  
      </div>
    )
  );
};

export default CookieConsent;